import { cn } from "@/lib/utils";

type ImportOrderReceiveProgressProps = {
  received: number;
  ordered: number;
  className?: string;
  size?: "sm" | "md";
};

export function ImportOrderReceiveProgress({
  received,
  ordered,
  className,
  size = "sm",
}: ImportOrderReceiveProgressProps) {
  const pct =
    ordered > 0 ? Math.min(100, Math.round((received / ordered) * 100)) : 0;
  const done = ordered > 0 && received >= ordered;

  return (
    <div className={cn("space-y-1.5", className)}>
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="text-muted-foreground">ຄວາມຄືບໜ້າຮັບ</span>
        <span className="font-medium tabular-nums">
          {received}/{ordered}
          <span className="font-normal text-muted-foreground"> ({pct}%)</span>
        </span>
      </div>
      <div
        className={cn(
          "overflow-hidden rounded-full bg-muted/70",
          size === "md" ? "h-2.5" : "h-1.5",
        )}
      >
        <div
          className={cn(
            "h-full rounded-full transition-[width]",
            done ? "bg-leaf" : pct > 0 ? "bg-secondary" : "bg-muted-foreground/25",
          )}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
